import { supabase } from './config';

/**
 * Create event
 */
export const createEvent = async (eventData) => {
  try {
    const { data, error } = await supabase
      .from('events')
      .insert({
        event_id: `event_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        place_id: eventData.placeId,
        place_name: eventData.placeName,
        place_address: eventData.placeAddress,
        place_photo_url: eventData.placePhotoUrl,
        place_icon: eventData.placeIcon,
        title: eventData.title,
        description: eventData.description,
        start_date_time: eventData.startDateTime,
        end_date_time: eventData.endDateTime,
        timezone: eventData.timezone,
        people_limit: parseInt(eventData.peopleLimit),
        created_by: eventData.createdBy,
        creator_id: eventData.creatorId,
        participants: [eventData.creatorId],
        latitude: eventData.latitude,
        longitude: eventData.longitude,
require_approve: eventData.require_approve || false,
        pending_requests: eventData.pending_requests || [],
gender_preference: eventData.gender_preference || ['man', 'woman', 'different'],
category: Array.isArray(eventData.category) ? eventData.category : (eventData.category ? [eventData.category] : ['entertainment']),
        age_min: eventData.age_min || 18,
        age_max: eventData.age_max || 99,
      })
      .select()
      .single();

    if (error) throw error;

    return { success: true, eventId: data.event_id, event: data };
  } catch (error) {
    console.error('Create event error:', error);
    return { success: false, error: error.message };
  }
};

export const getAllEvents = async () => {
  try {
const { data, error } = await supabase
      .from('events')
      .select('*')
      .or('hidden.is.null,hidden.eq.false')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    
    // Map database columns to camelCase
    const events = data.map(event => ({
      eventId: event.event_id,
      placeId: event.place_id,
      placeName: event.place_name,
      placeAddress: event.place_address,
      placePhotoUrl: event.place_photo_url,
      placeIcon: event.place_icon,
      title: event.title,
      description: event.description,
      startDateTime: event.start_date_time,
      endDateTime: event.end_date_time,
      timezone: event.timezone,
      peopleLimit: event.people_limit,
      createdBy: event.created_by,
      creatorId: event.creator_id,
      participants: event.participants,
      latitude: event.latitude,
      longitude: event.longitude,
      createdAt: event.created_at,
      archived: event.archived || false,
requireApprove: event.require_approve || false,
      pendingRequests: event.pending_requests || [],
genderPreference: event.gender_preference || ['man', 'woman', 'different'],
category: Array.isArray(event.category) ? event.category : (event.category ? [event.category] : ['entertainment']),
      ageMin: event.age_min || 18,
      ageMax: event.age_max || 99
    }));
    
    return {
      success: true,
      events
    };
  } catch (error) {
    console.error('❌ Error getting events:', error);
    return {
      success: false,
      error: error.message,
      events: []
    };
  }
};

/**
 * Delete event
 */
export const deleteEvent = async (eventId) => {
  try {
    const { error } = await supabase
      .from('events')
      .delete()
      .eq('event_id', eventId);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error('Delete event error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Update event
 */
export const updateEvent = async (eventId, updates) => {
  try {
    // Convert camelCase to snake_case for database columns
    const dbUpdates = {};
    
    if (updates.placeId !== undefined) dbUpdates.place_id = updates.placeId;
    if (updates.placeName !== undefined) dbUpdates.place_name = updates.placeName;
    if (updates.placeAddress !== undefined) dbUpdates.place_address = updates.placeAddress;
    if (updates.placePhotoUrl !== undefined) dbUpdates.place_photo_url = updates.placePhotoUrl;
    if (updates.placeIcon !== undefined) dbUpdates.place_icon = updates.placeIcon;
    if (updates.title !== undefined) dbUpdates.title = updates.title;
    if (updates.description !== undefined) dbUpdates.description = updates.description;
    if (updates.startDateTime !== undefined) dbUpdates.start_date_time = updates.startDateTime;
    if (updates.endDateTime !== undefined) dbUpdates.end_date_time = updates.endDateTime;
    if (updates.timezone !== undefined) dbUpdates.timezone = updates.timezone;
    if (updates.peopleLimit !== undefined) dbUpdates.people_limit = updates.peopleLimit;
    if (updates.participants !== undefined) dbUpdates.participants = updates.participants;
    if (updates.archived !== undefined) dbUpdates.archived = updates.archived;
if (updates.requireApprove !== undefined) dbUpdates.require_approve = updates.requireApprove;
    if (updates.genderPreference !== undefined) dbUpdates.gender_preference = updates.genderPreference;
    if (updates.category !== undefined) dbUpdates.category = updates.category;
    if (updates.ageMin !== undefined) dbUpdates.age_min = updates.ageMin;
    if (updates.ageMax !== undefined) dbUpdates.age_max = updates.ageMax;
    
    const { error } = await supabase
      .from('events')
      .update(dbUpdates)
      .eq('event_id', eventId);

    if (error) throw error;

    console.log('✅ Event updated:', eventId);
    return { success: true };
  } catch (error) {
    console.error('Update event error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Subscribe to events changes (real-time)
 */
export const subscribeToEvents = (callback) => {
  const subscription = supabase
    .channel('events-channel')
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'events' },
      (payload) => {
        callback(payload);
      }
    )
    .subscribe();

  return subscription;
};

